module.exports = __webpack_public_path__ + "static/media/taskmanager.0ad9c1c3.webp";